export default __webpack_public_path__ + "static/media/ln-white.c805f732.svg";